module.exports = __webpack_public_path__ + "static/media/get-started-3.9bfb9060.svg";